import styled from 'styled-components';

import { grayscale, slate } from '@vimeo/iris/color';
import { Pop } from '@vimeo/iris/components';

export const PopDivider = styled(Pop.Divider)`
  border-color: ${({ theme }) => (theme.name === 'light' ? slate(100) : grayscale(600))};
`;

export const PopItem = styled(Pop.Item)`
  font-size: 0.9rem;
  display: flex;
`;

export const Link = styled.a`
  text-decoration: none;
`;
